import script from "./InputTel.vue?vue&type=script&setup=true&lang=js"
export * from "./InputTel.vue?vue&type=script&setup=true&lang=js"

import "./InputTel.vue?vue&type=style&index=0&id=4234c64d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4234c64d"]])

export default __exports__